var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H19C19.41 18.75 19.75 19.09 19.75 19.5C19.75 19.91 19.41 20.25 19 20.25Z",
    fill: "#F4F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.25C16.59 22.25 16.25 21.91 16.25 21.5V17.5C16.25 17.09 16.59 16.75 17 16.75C17.41 16.75 17.75 17.09 17.75 17.5V21.5C17.75 21.91 17.41 22.25 17 22.25Z",
    fill: "#F4F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6587 11.62C12.6287 11.62 12.6087 11.62 12.5787 11.62C12.5287 11.61 12.4587 11.61 12.3987 11.62C9.49873 11.53 7.30873 9.25 7.30873 6.44C7.29873 5.06 7.83873 3.76 8.81873 2.78C9.79873 1.8 11.0987 1.25 12.4887 1.25C15.3487 1.25 17.6787 3.58 17.6787 6.44C17.6787 9.25 15.4887 11.52 12.6887 11.62C12.6787 11.62 12.6687 11.62 12.6587 11.62ZM12.4887 2.75C11.4987 2.75 10.5787 3.14 9.87873 3.83C9.18873 4.53 8.80873 5.45 8.80873 6.43C8.80873 8.43 10.3687 10.05 12.3587 10.11C12.4187 10.1 12.5487 10.1 12.6787 10.11C14.6487 10.02 16.1787 8.41 16.1787 6.43C16.1787 4.41 14.5187 2.75 12.4887 2.75Z",
    fill: "#FBFAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4902 22.5597C10.4502 22.5597 8.52016 22.0297 7.06016 21.0497C5.67016 20.1197 4.91016 18.8497 4.91016 17.4797C4.91016 16.1097 5.68016 14.8497 7.06016 13.9297C10.0502 11.9297 14.9102 11.9297 17.9002 13.9297C18.2402 14.1597 18.3402 14.6297 18.1102 14.9697C17.8802 15.3197 17.4102 15.4097 17.0702 15.1797C14.5802 13.5197 10.3802 13.5197 7.89016 15.1797C6.93016 15.8197 6.41016 16.6297 6.41016 17.4797C6.41016 18.3297 6.93016 19.1597 7.89016 19.7997C9.10016 20.6097 10.7302 21.0497 12.4802 21.0497C12.8902 21.0497 13.2302 21.3897 13.2302 21.7997C13.2302 22.2097 12.9002 22.5597 12.4902 22.5597Z",
    fill: "#FBFAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAdd);
export default __webpack_public_path__ + "static/media/profile-add.1b496247b4bfedb17ad8e04508139c86.svg";
export { ForwardRef as ReactComponent };